/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, optional as codecOptional } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { JunitTestLogBase } from './JunitTestLogBase';
const JunitTestLogParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['points', /* #__PURE__ */ codecOptional(codecNumber)],
]), JunitTestLogBase);
export class JunitTestLog extends JunitTestLogBase {
    static decode(input) {
        return JunitTestLogParser.decode(input).map(res => new JunitTestLog(res));
    }
    static unsafeDecode(input) {
        return JunitTestLog.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JunitTestLogParser.encode(data);
    }
    static schema() {
        return JunitTestLogParser.schema();
    }
}
